export default __webpack_public_path__ + "static/media/sqllite.646ec76a.svg";